import { Union, Record } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { option_type, unit_type, string_type, array_type, tuple_type, bool_type, getEnumValues, union_type, lambda_type, float64_type, record_type, uint32_type, enum_type, int32_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { SeasonModule_span } from "./Model/Crops.js";
import { CropModule_regrows, Crop_$reflection, FarmCropModule_items, CropModule_items, Crop, CropModule_isForage, ForageCropModule_seedItem, CropModule_canGetOwnSeedsFromSeedMaker, CropModule_seed, Growth_daysNeededFor, CropModule_regrowTime, Growth_maxHarvests, DateModule_totalDays, CropModule_seasons, SeasonsModule_contains, DateModule_daySpan } from "./Model/Crops.js";
import { mapIndexed, tryFind, setItem, zip, tryHead, append as append_1, allPairs, concat, sumBy, tryFindIndex, choose, map2, initialize, min, minBy, fill, map as map_1, sortInPlaceBy, item as item_4 } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { empty, toArray, cons } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { arrayHash, equalArrays, structuralHash, int32ToString, curry3, curry4, max, min as min_1, compare, comparePrimitives, equals } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Game_xpItemsPerHarvest, Game_xpPerItem, Game_cropItemQuantitiesByQuality, Game_productPriceAndQuality, Game_xpPerHarvest, Game_farmCropItemQuantitiesByQuality, Game_forageCropItemQuantityByQuality, Game_seedItemSellPrice, Game_forageCropMainItemQuantity, Game_farmCropMainItemQuantity, Game_itemPriceByQuality, Game_itemPrice, Game_productNormalizedPriceByQuality, Game_productPriceByQuality, Game_productNormalizedPrice, Game_productPrice, Game_forageCropSeedRecipeUnlocked, Game_processorUnlocked, Game_productUnlocked, GameDataModule_products, Game_inSeasonCrops, Game_seedPrice, Game_destroyFertilizerProb, Game_growthTime, Location } from "./Model/Game.js";
import { CustomChoice$2_$reflection, Array_map2Reduce, Util_compareBy, CustomChoice$2, Util_minBy, Option_merge, Selection_selectedValue, Util_maxBy, Array_mapReduce } from "./Types.js";
import { map2 as map2_1, map3, defaultArg, value as value_4, toArray as toArray_1, some, map } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { Table_tryFind } from "./Model/Prelude.js";
import { getItemFromDict } from "./fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { Qualities_mult, Fertilizer_$reflection, Qualities$1_$reflection, FertilizerModule_Opt_name, Qualities_zero, Qualities_dot, Qualities$1, Qualities_multipliers } from "./Model/Skills.js";
import { iterate, empty as empty_1, singleton, delay, toList, append, map as map_2 } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { FSharpMap__get_Item } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { FSharpSet__Contains, FSharpSet__get_IsEmpty } from "./fable_modules/fable-library-js.4.29.0/Set.js";
import { ProductModule_quantityPerInput, Product_$reflection, ProcessorModule_seedMakerExpectedQuantity, ProductModule_processor } from "./Model/Items.js";
import { min as min_2, max as max_1 } from "./fable_modules/fable-library-js.4.29.0/Double.js";
import { Option_defaultOrMap } from "./Model/Prelude.js";
import { Result_Bind, Result_Map, FSharpResult$2 } from "./fable_modules/fable-library-js.4.29.0/Result.js";
import { solve, lessEq, equalTo } from "yalps";
import { Array_groupBy } from "./fable_modules/fable-library-js.4.29.0/Seq2.js";

export class GrowthSpan extends Record {
    constructor(StartSeason, EndSeason, TotalDays, GrowthTime, Harvests) {
        super();
        this.StartSeason = (StartSeason | 0);
        this.EndSeason = (EndSeason | 0);
        this.TotalDays = TotalDays;
        this.GrowthTime = GrowthTime;
        this.Harvests = Harvests;
    }
}

export function GrowthSpan_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.GrowthSpan", [], GrowthSpan, () => [["StartSeason", enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]])], ["EndSeason", enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]])], ["TotalDays", uint32_type], ["GrowthTime", uint32_type], ["Harvests", uint32_type]]);
}

function consecutiveInSeasonDays(startDate, endDate, seasons) {
    const nthSeason = SeasonModule_span(startDate.Season, endDate.Season);
    const days = DateModule_daySpan(startDate, endDate);
    const nextSeason = (start_1_mut, finish_1_mut, totalDays_mut, list_mut) => {
        nextSeason:
        while (true) {
            const start_1 = start_1_mut, finish_1 = finish_1_mut, totalDays = totalDays_mut, list = list_mut;
            if ((finish_1 < nthSeason.length) && SeasonsModule_contains(item_4(finish_1, nthSeason), seasons)) {
                start_1_mut = start_1;
                finish_1_mut = (finish_1 + 1);
                totalDays_mut = (totalDays + item_4(finish_1, days));
                list_mut = list;
                continue nextSeason;
            }
            else {
                const list_1 = (totalDays === 0) ? list : cons([[item_4(start_1, nthSeason), item_4(finish_1 - 1, nthSeason)], totalDays], list);
                if (finish_1 < nthSeason.length) {
                    start_1_mut = (finish_1 + 1);
                    finish_1_mut = (finish_1 + 1);
                    totalDays_mut = 0;
                    list_mut = list_1;
                    continue nextSeason;
                }
                else {
                    return list_1;
                }
            }
            break;
        }
    };
    return toArray(nextSeason(0, 0, 0, empty()));
}

/**
 * Returns the GrowthSpan for this crop that has the most harvests,
 * and, in the case of a tie, the date span with the least days.
 */
export function bestGrowthSpan(vars, fertilizer, crop) {
    const consecutiveDays = equals(vars.Location, new Location(0, [])) ? consecutiveInSeasonDays(vars.StartDate, vars.EndDate, CropModule_seasons(crop)) : [[[vars.StartDate.Season, vars.EndDate.Season], DateModule_totalDays(vars.StartDate, vars.EndDate)]];
    if (consecutiveDays.length === 0) {
        return undefined;
    }
    else {
        const time = Game_growthTime(vars, fertilizer, crop);
        let patternInput;
        sortInPlaceBy((tuple) => tuple[1], consecutiveDays, {
            Compare: comparePrimitives,
        });
        patternInput = Array_mapReduce((a, b) => Util_maxBy((tuple_1) => tuple_1[1], a, b), (tupledArg) => {
            const days = tupledArg[1];
            return [[tupledArg[0], days], Growth_maxHarvests(CropModule_regrowTime(crop), time, days)];
        }, consecutiveDays);
        const harvests = patternInput[1];
        if (harvests === 0) {
            return undefined;
        }
        else {
            return new GrowthSpan(patternInput[0][0][0], patternInput[0][0][1], patternInput[0][1], time, harvests);
        }
    }
}

export function timeNormalizationDivisor(growthSpan, crop, _arg) {
    switch (_arg.tag) {
        case 1:
            return Growth_daysNeededFor(CropModule_regrowTime(crop), growthSpan.GrowthTime, growthSpan.Harvests);
        case 2:
            return growthSpan.TotalDays / 28;
        default:
            return 1;
    }
}

export function replacedFertilizerPerHarvest(settings, crop) {
    if (settings.Profit.PayForDestroyedFertilizer) {
        return Game_destroyFertilizerProb(settings.Game, crop);
    }
    else {
        return 0;
    }
}

export function seedPriceValueFromVendor(data, settings, vendor, seed) {
    return map((_arg_1) => Game_seedPrice(data, settings.Game, seed, _arg_1), Table_tryFind(vendor, getItemFromDict(data.SeedPrices.fields[0], seed)));
}

export function customSellPriceValue(quality, price, preserveQuality) {
    if (preserveQuality) {
        const value_2 = item_4(quality, Qualities_multipliers.fields[0]) * price;
        return value_2 >>> 0;
    }
    else {
        return price;
    }
}

export function customSellPriceValueByQuality(price, preserveQuality) {
    if (preserveQuality) {
        return new Qualities$1(map_1((mult) => {
            const value_2 = mult * price;
            return value_2 >>> 0;
        }, Qualities_multipliers.fields[0], Uint32Array));
    }
    else {
        return new Qualities$1(fill(new Uint32Array(4), 0, 4, price));
    }
}

function Selected_mapSelected(table, selected) {
    return map_2((key) => getItemFromDict(table.fields[0], key), selected);
}

function Selected_mapSelectedPrices(prices, selected) {
    return map_2((vendor) => [vendor, getItemFromDict(prices.fields[0], vendor)], selected);
}

export function Selected_fertilizers(data, settings) {
    return Selected_mapSelected(data.Fertilizers, settings.Selected.Fertilizers);
}

export function Selected_fertilizersOpt(data, settings) {
    const source_2 = map_2((Value) => Value, Selected_fertilizers(data, settings));
    return append(toList(delay(() => (settings.Selected.NoFertilizer ? singleton(undefined) : empty_1()))), source_2);
}

export function Selected_fertilizerVendorsAndPrices(data, settings, fertilizer) {
    const selected = FSharpMap__get_Item(settings.Selected.FertilizerPrices, fertilizer);
    return Selected_mapSelectedPrices(getItemFromDict(data.FertilizerPrices.fields[0], fertilizer), selected);
}

export function Selected_fertilizerPrices(data, settings, fertilizer) {
    const selected = FSharpMap__get_Item(settings.Selected.FertilizerPrices, fertilizer);
    return Selected_mapSelected(getItemFromDict(data.FertilizerPrices.fields[0], fertilizer), selected);
}

export function Selected_crops(data, settings) {
    return Selected_mapSelected(data.Crops, settings.Selected.Crops);
}

export function Selected_inSeasonCrops(data, settings) {
    return Game_inSeasonCrops(settings.Game, Selected_crops(data, settings));
}

export function Selected_cropHasPrice(settings, seed) {
    if (!FSharpSet__get_IsEmpty(FSharpMap__get_Item(settings.Selected.SeedPrices, seed))) {
        return true;
    }
    else {
        return Selection_selectedValue(seed, settings.Selected.CustomSeedPrices) != null;
    }
}

export function Selected_seedVendorsAndPrices(data, settings, seed) {
    const selected = FSharpMap__get_Item(settings.Selected.SeedPrices, seed);
    return Selected_mapSelectedPrices(getItemFromDict(data.SeedPrices.fields[0], seed), selected);
}

export function Selected_seedVendorsAndPriceValues(data, settings, seed) {
    return map_2((tupledArg) => [tupledArg[0], Game_seedPrice(data, settings.Game, seed, tupledArg[1])], Selected_seedVendorsAndPrices(data, settings, seed));
}

export function Selected_seedPrices(data, settings, seed) {
    const selected = FSharpMap__get_Item(settings.Selected.SeedPrices, seed);
    return Selected_mapSelected(getItemFromDict(data.SeedPrices.fields[0], seed), selected);
}

export function Selected_seedPriceValues(data, settings, seed) {
    return map_2((_arg) => Game_seedPrice(data, settings.Game, seed, _arg), Selected_seedPrices(data, settings, seed));
}

export function Selected_unlockedProducts(data, settings, item) {
    const selected = FSharpMap__get_Item(settings.Selected.Products, item);
    const array = GameDataModule_products(data, item);
    return array.filter((product) => {
        if (Game_productUnlocked(data, settings.Game)(product)) {
            return FSharpSet__Contains(selected, ProductModule_processor(product));
        }
        else {
            return false;
        }
    });
}

export function Selected_unlockedUseSeedsFromSeedMaker(data, settings, crop) {
    if (Game_processorUnlocked(data, settings.Game, "Seed Maker") && FSharpSet__Contains(settings.Selected.UseSeedMaker, CropModule_seed(crop))) {
        return CropModule_canGetOwnSeedsFromSeedMaker((key) => getItemFromDict(data.Items.fields[0], key), crop);
    }
    else {
        return false;
    }
}

export function Selected_unlockedForageSeedsSellAndUse(settings, crop) {
    if (Game_forageCropSeedRecipeUnlocked(settings.Game, crop)) {
        return [FSharpSet__Contains(settings.Selected.SellRaw, ForageCropModule_seedItem(crop)), FSharpSet__Contains(settings.Selected.UseForageSeeds, crop.Seed)];
    }
    else {
        return [false, false];
    }
}

export function Selected_unlockedForageSeedsAnyUsage(settings, crop) {
    const patternInput = Selected_unlockedForageSeedsSellAndUse(settings, crop);
    if (patternInput[0]) {
        return true;
    }
    else {
        return patternInput[1];
    }
}

export function Selected_useHarvestedSeeds(settings, seed, item) {
    if (seed === item) {
        return FSharpSet__Contains(settings.Selected.UseHarvestedSeeds, seed);
    }
    else {
        return false;
    }
}

function Price_minVendorAndPrice(selectedPrices, data, settings, customPrices, key) {
    let prices, patternInput;
    return Option_merge((a, b) => Util_minBy((tuple_1) => tuple_1[1], a, b), (prices = Array.from(selectedPrices(data, settings, key)), (prices.length === 0) ? undefined : ((patternInput = minBy((tuple) => tuple[1], prices, {
        Compare: compare,
    }), [new CustomChoice$2(0, [patternInput[0]]), patternInput[1]]))), map((price_2) => [new CustomChoice$2(1, [undefined]), price_2], Selection_selectedValue(key, customPrices)));
}

function Price_minPrice(selectedPriceValues, data, settings, customPrices, key) {
    const prices = Array.from(selectedPriceValues(data, settings, key));
    const b = (prices.length === 0) ? undefined : some(min(prices, {
        Compare: compare,
    }));
    return Option_merge((e, e_1) => min_1(compare, e, e_1), Selection_selectedValue(key, customPrices), b);
}

export function Price_fertilizerMinVendorAndPrice(data, settings, fertilizer) {
    return Price_minVendorAndPrice(Selected_fertilizerVendorsAndPrices, data, settings, settings.Selected.CustomFertilizerPrices, fertilizer);
}

export function Price_fertilizerMinPrice(data, settings, fertilizer) {
    return Price_minPrice(Selected_fertilizerPrices, data, settings, settings.Selected.CustomFertilizerPrices, fertilizer);
}

export function Price_seedMinVendorAndPrice(data, settings, seed) {
    return Price_minVendorAndPrice(Selected_seedVendorsAndPriceValues, data, settings, settings.Selected.CustomSeedPrices, seed);
}

export function Price_seedMinPrice(data, settings, seed) {
    return Price_minPrice(Selected_seedPriceValues, data, settings, settings.Selected.CustomSeedPrices, seed);
}

function Price_itemMaxProductPriceBy(projection, data, settings, item, quality) {
    const products = Selected_unlockedProducts(data, settings, item);
    if (products.length === 0) {
        return undefined;
    }
    else {
        return some(Array_mapReduce((e, e_1) => max(compare, e, e_1), curry4(projection)(data)(settings.Game)(quality), products));
    }
}

export function Price_itemMaxProductPrice(data, settings, item, quality) {
    return Price_itemMaxProductPriceBy(Game_productPrice, data, settings, item, quality);
}

export function Price_itemMaxProductPriceNormalized(data, settings, item, quality) {
    return Price_itemMaxProductPriceBy(Game_productNormalizedPrice, data, settings, item, quality);
}

function Price_itemMaxProductPriceByQualityBy(projection, data, settings, item) {
    let prices;
    const array = Selected_unlockedProducts(data, settings, item);
    prices = map_1(curry3(projection)(data)(settings.Game), array);
    if (prices.length === 0) {
        return undefined;
    }
    else {
        return new Qualities$1(initialize(4, (arg) => Array_mapReduce((e, e_1) => max(compare, e, e_1), (arg10$0040) => item_4(arg, arg10$0040.fields[0]), prices)));
    }
}

export function Price_itemMaxProductPriceByQuality(data, settings, item) {
    return Price_itemMaxProductPriceByQualityBy(Game_productPriceByQuality, data, settings, item);
}

export function Price_itemMaxProductNormalizedPriceByQuality(data, settings, item) {
    return Price_itemMaxProductPriceByQualityBy(Game_productNormalizedPriceByQuality, data, settings, item);
}

function Price_itemSelectedRawPriceValue(data, settings, seed, item, quality) {
    if (FSharpSet__Contains(settings.Selected.SellRaw, item)) {
        return Game_itemPrice(settings.Game, CropModule_isForage(getItemFromDict(data.Crops.fields[0], seed)), getItemFromDict(data.Items.fields[0], item), quality);
    }
    else {
        return undefined;
    }
}

function Price_itemSelectedRawPriceValueByQuality(data, settings, seed, item) {
    if (FSharpSet__Contains(settings.Selected.SellRaw, item)) {
        return Game_itemPriceByQuality(settings.Game, CropModule_isForage(getItemFromDict(data.Crops.fields[0], seed)), getItemFromDict(data.Items.fields[0], item));
    }
    else {
        return undefined;
    }
}

function Price_selectedCustomSellPriceValue(selected, item, quality) {
    return map((tupledArg) => customSellPriceValue(quality, tupledArg[0], tupledArg[1]), Selection_selectedValue(item, selected.CustomSellPrices));
}

function Price_selectedCustomSellPriceValueByQuality(selected, item) {
    return map((tupledArg) => customSellPriceValueByQuality(tupledArg[0], tupledArg[1]), Selection_selectedValue(item, selected.CustomSellPrices));
}

export function Price_itemMaxNormalizedPrice(data, settings, seed, item, quality) {
    let b_2;
    const b = map((value) => value, Price_itemSelectedRawPriceValue(data, settings, seed, item, quality));
    b_2 = Option_merge(max_1, Price_itemMaxProductPriceNormalized(data, settings, item, quality), b);
    return Option_merge(max_1, map((value_1) => value_1, Price_selectedCustomSellPriceValue(settings.Selected, item, quality)), b_2);
}

export function Price_itemMaxNormalizedPriceByQuality(data, settings, seed, item) {
    let b_1;
    return Option_merge((arg10$0040_3, arg20$0040_1) => (new Qualities$1(map2(max_1, arg10$0040_3.fields[0], arg20$0040_1.fields[0], Float64Array))), map((arg10$0040) => (new Qualities$1(map_1((value) => value, arg10$0040.fields[0], Float64Array))), Price_selectedCustomSellPriceValueByQuality(settings.Selected, item)), (b_1 = map((arg10$0040_1) => (new Qualities$1(map_1((value_1) => value_1, arg10$0040_1.fields[0], Float64Array))), Price_itemSelectedRawPriceValueByQuality(data, settings, seed, item)), Option_merge((arg10$0040_2, arg20$0040) => (new Qualities$1(map2(max_1, arg10$0040_2.fields[0], arg20$0040.fields[0], Float64Array))), Price_itemMaxProductNormalizedPriceByQuality(data, settings, item), b_1)));
}

function Price_itemMaxProductAndPriceByQualityBy(projection, data, settings, item) {
    const products = map_1((product) => [product, projection(data, settings.Game, product)], Selected_unlockedProducts(data, settings, item));
    if (products.length === 0) {
        return undefined;
    }
    else {
        return new Qualities$1(initialize(4, (arg) => Array_mapReduce((a, b) => Util_maxBy((tuple) => tuple[1], a, b), (tupledArg) => [tupledArg[0], item_4(arg, tupledArg[1].fields[0])], products)));
    }
}

export function Price_itemMaxProductAndPriceByQuality(data, settings, item) {
    return Price_itemMaxProductAndPriceByQualityBy(Game_productPriceByQuality, data, settings, item);
}

export function Price_itemMaxProductAndNormalizedPriceByQuality(data, settings, item) {
    return Price_itemMaxProductAndPriceByQualityBy(Game_productNormalizedPriceByQuality, data, settings, item);
}

export function Price_itemMaxSellAsAndNormalizedPrice(data, settings, seed, item) {
    const sellAs = choose((x) => x, [map((arg10$0040) => (new Qualities$1(map_1((price) => [undefined, price], arg10$0040.fields[0]))), Price_itemSelectedRawPriceValueByQuality(data, settings, seed, item)), map((custom) => (new Qualities$1(map_1((price_2) => [new CustomChoice$2(1, [custom]), price_2], customSellPriceValueByQuality(custom[0], custom[1]).fields[0]))), Selection_selectedValue(item, settings.Selected.CustomSellPrices)), map((arg10$0040_2) => (new Qualities$1(map_1((tupledArg) => [new CustomChoice$2(0, [tupledArg[0]]), tupledArg[1]], arg10$0040_2.fields[0]))), Price_itemMaxProductAndNormalizedPriceByQuality(data, settings, item))]);
    if (sellAs.length === 0) {
        return undefined;
    }
    else {
        return new Qualities$1(initialize(4, (arg) => Array_mapReduce((a, b) => Util_maxBy((tuple) => tuple[1], a, b), (arg10$0040_3) => item_4(arg, arg10$0040_3.fields[0]), sellAs)));
    }
}

export function fertilizerCost(data, settings, fertilizer) {
    if (settings.Profit.PayForFertilizer) {
        return Price_fertilizerMinPrice(data, settings, fertilizer);
    }
    else {
        return 0;
    }
}

export function fertilizerCostOpt(data, settings) {
    return (_arg) => Option_defaultOrMap(0, (fertilizer) => fertilizerCost(data, settings, fertilizer), _arg);
}

function fertilizerRelevantVendorAndPrice(data, settings, fertilizer) {
    if (fertilizer != null) {
        if (!settings.Profit.PayForFertilizer) {
            return undefined;
        }
        else {
            const fertilizer_1 = fertilizer;
            return some(Price_fertilizerMinVendorAndPrice(data, settings, fertilizer_1.Name));
        }
    }
    else {
        return undefined;
    }
}

function invalidReasons(hasOneHarvest, hasFertilierPrice, hasEnoughSeeds) {
    return new FSharpResult$2(1, [((hasOneHarvest ? 0 : 1) | (hasFertilierPrice ? 0 : 2)) | (hasEnoughSeeds ? 0 : 4)]);
}

function farmCropMaxNonBoughtSeeds(data, settings, crop) {
    let mainItemQuantity, matchValue, quantity, item_1, quantity_1;
    return ((mainItemQuantity = Game_farmCropMainItemQuantity(settings.Game, crop), Selected_unlockedUseSeedsFromSeedMaker(data, settings, new Crop(0, [crop])) ? (ProcessorModule_seedMakerExpectedQuantity(crop.Seed) * mainItemQuantity) : (Selected_useHarvestedSeeds(settings, crop.Seed, crop.Item) ? mainItemQuantity : 0))) + ((matchValue = crop.ExtraItem, (matchValue != null) ? (((quantity = matchValue[1], Selected_useHarvestedSeeds(settings, crop.Seed, matchValue[0]))) ? ((item_1 = matchValue[0], (quantity_1 = matchValue[1], quantity_1))) : 0) : 0));
}

function forageCropMaxNonBoughtSeeds(data, settings, crop) {
    return max_1(Selected_unlockedForageSeedsSellAndUse(settings, crop)[1] ? 10 : 0, Selected_unlockedUseSeedsFromSeedMaker(data, settings, new Crop(1, [crop])) ? ProcessorModule_seedMakerExpectedQuantity(crop.Seed) : 0) * Game_forageCropMainItemQuantity(settings.Game, crop);
}

function maxNonBoughtSeeds(data, settings, crop) {
    if (crop.tag === 1) {
        return forageCropMaxNonBoughtSeeds(data, settings, crop.fields[0]);
    }
    else {
        return farmCropMaxNonBoughtSeeds(data, settings, crop.fields[0]);
    }
}

export function canMakeEnoughSeeds(data, settings, crop) {
    const matchValue = settings.Profit.SeedStrategy;
    switch (matchValue.tag) {
        case 0:
            return Selected_cropHasPrice(settings, CropModule_seed(crop));
        case 1:
            if (Selected_cropHasPrice(settings, CropModule_seed(crop))) {
                return true;
            }
            else {
                return maxNonBoughtSeeds(data, settings, crop) >= 1;
            }
        default:
            return true;
    }
}

export class RegrowCropProfitData extends Record {
    constructor(ProfitPerHarvest, HarvestsForMinCost, MinCost, Cost) {
        super();
        this.ProfitPerHarvest = ProfitPerHarvest;
        this.HarvestsForMinCost = HarvestsForMinCost;
        this.MinCost = MinCost;
        this.Cost = Cost;
    }
}

export function RegrowCropProfitData_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.RegrowCropProfitData", [], RegrowCropProfitData, () => [["ProfitPerHarvest", float64_type], ["HarvestsForMinCost", uint32_type], ["MinCost", float64_type], ["Cost", lambda_type(uint32_type, float64_type)]]);
}

function Profit_constantRegrowData(profit, seedCost) {
    return new RegrowCropProfitData(profit, 1, seedCost, (arg10$0040) => seedCost);
}

function Profit_seedOpportunityCostsAndQuantityPerHarvest(data, settings, seedPrice, crop, prices, quantities) {
    const seed = CropModule_seed(crop);
    const seedCostsAndQuantity = [];
    const seedPriceValue = Option_defaultOrMap(Infinity, (value) => value, seedPrice);
    const addCostAndQuantity = (item, seedsPerInput) => {
        const prices_1 = item_4(item, prices);
        const quantities_1 = item_4(item, quantities);
        for (let i = 0; i <= 3; i++) {
            const cost = item_4(i, prices_1.fields[0]) / seedsPerInput;
            const seeds = item_4(i, quantities_1.fields[0]) * seedsPerInput;
            if ((cost < seedPriceValue) && (seeds > 0)) {
                void (seedCostsAndQuantity.push([cost, seeds]));
            }
        }
    };
    if (Selected_unlockedUseSeedsFromSeedMaker(data, settings, crop)) {
        addCostAndQuantity(0, ProcessorModule_seedMakerExpectedQuantity(seed));
    }
    iterate((i_1) => {
        addCostAndQuantity(i_1, 1);
    }, toArray_1(tryFindIndex((item_1) => Selected_useHarvestedSeeds(settings, seed, item_1), CropModule_items(crop))));
    seedCostsAndQuantity.sort((delegateArg, delegateArg_1) => Util_compareBy((tuple) => tuple[0], delegateArg, delegateArg_1));
    return seedCostsAndQuantity;
}

function Profit_seedCostCalc(seedPrice, opportunityCostsAndSeedsPerHarvest, harvests) {
    let seedsLeft = 1;
    let totalCost = 0;
    let i = 0;
    while ((i < opportunityCostsAndSeedsPerHarvest.length) && (seedsLeft > 0)) {
        const patternInput = item_4(i, opportunityCostsAndSeedsPerHarvest);
        const seedsMade = min_2(seedsLeft, patternInput[1] * harvests);
        totalCost = (totalCost + (patternInput[0] * seedsMade));
        seedsLeft = (seedsLeft - seedsMade);
        i = ((i + 1) | 0);
    }
    if (seedPrice == null) {
        if (seedsLeft === 0) {
            return totalCost;
        }
        else {
            return undefined;
        }
    }
    else {
        const price = seedPrice;
        return totalCost + (price * seedsLeft);
    }
}

function Profit_trySeedCost(data, settings, seedPrice, crop, prices, quantities, harvests) {
    return Profit_seedCostCalc(seedPrice, Profit_seedOpportunityCostsAndQuantityPerHarvest(data, settings, seedPrice, crop, prices, quantities), harvests);
}

function Profit_farmCropTrySeedCost(data, settings, seedPrice, crop, prices) {
    if ((seedPrice == null) && (farmCropMaxNonBoughtSeeds(data, settings, crop) < 1)) {
        return undefined;
    }
    else {
        return (quantities) => ((harvests) => value_4(Profit_trySeedCost(data, settings, seedPrice, new Crop(0, [crop]), prices, quantities, harvests)));
    }
}

function Profit_profitCalc(prices, quantities) {
    return Array_map2Reduce((x, y) => (x + y), Qualities_dot, prices, quantities);
}

function Profit_forageCropProfitPerHarvestCalc(prices, quantities) {
    return sumBy((b) => Qualities_dot(quantities, b), prices, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    });
}

function Profit_cropItemNormalizedPricesByQuality(data, settings, seed, items) {
    return map_1((arg) => defaultArg(Price_itemMaxNormalizedPriceByQuality(data, settings, seed, arg), Qualities_zero), items);
}

function Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop) {
    return Profit_cropItemNormalizedPricesByQuality(data, settings, crop.Seed, FarmCropModule_items(crop));
}

class Profit_Variable extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BoughtSeeds", "SoldItem", "MadeSeeds", "UsedToCraftForageSeeds", "SoldForageSeeds", "UsedForageSeeds"];
    }
}

function Profit_Variable_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Query.Profit.Variable", [], Profit_Variable, () => [[], [["Item1", uint32_type], ["Item2", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])]], [["Item1", uint32_type], ["Item2", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])]], [["Item1", uint32_type], ["Item2", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])]], [], []]);
}

function Profit_forageCropNetProfitSolution(data, settings, crop, seedTarget, seedPrice, prices, quantities) {
    let price, tupledArg_1, tupledArg_2;
    const patternInput = Selected_unlockedForageSeedsSellAndUse(settings, crop);
    let validQualities;
    const array = getEnumValues(enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]]));
    validQualities = array.filter((q) => (item_4(q, quantities.fields[0]) > 0));
    const allocatedToForageSeeds = map_1((item) => (item.toString() + "@Forage Seeds"), crop.Foragables);
    const constraints = concat([[["Seeds", equalTo(seedTarget)]], map_1((tupledArg) => {
        const quality_2 = tupledArg[1] | 0;
        return [tupledArg[0].toString() + ("@" + int32ToString(quality_2)), lessEq(item_4(quality_2, quantities.fields[0]))];
    }, allPairs(crop.Foragables, validQualities)), map_1((quantity) => [quantity, equalTo(0)], allocatedToForageSeeds)]);
    const variables = [];
    let matchResult, price_1;
    if (seedPrice != null) {
        if ((price = seedPrice, seedTarget > 0)) {
            matchResult = 0;
            price_1 = seedPrice;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            void (variables.push([new Profit_Variable(0, []), [["Profit", -price_1], ["Seeds", 1]]]));
            break;
        }
    }
    for (let i = 0; i <= (crop.Foragables.length - 1); i++) {
        const item_2 = item_4(i, crop.Foragables);
        const prices_1 = item_4(i, prices);
        const forageSeedsAllocation = item_4(i, allocatedToForageSeeds);
        for (let idx = 0; idx <= (validQualities.length - 1); idx++) {
            const quality_5 = item_4(idx, validQualities) | 0;
            const oneItem = [item_2.toString() + ("@" + int32ToString(quality_5)), 1];
            const itemQuality = [item_2, quality_5];
            void (variables.push([(tupledArg_1 = itemQuality, new Profit_Variable(1, [tupledArg_1[0], tupledArg_1[1]])), [["Profit", item_4(quality_5, prices_1.fields[0])], oneItem]]));
            void (variables.push([(tupledArg_2 = itemQuality, new Profit_Variable(3, [tupledArg_2[0], tupledArg_2[1]])), [[forageSeedsAllocation, 1], oneItem]]));
        }
    }
    if ((seedTarget > 0) && Selected_unlockedUseSeedsFromSeedMaker(data, settings, new Crop(1, [crop]))) {
        const item_3 = item_4(0, crop.Foragables);
        const quantity_1 = ProcessorModule_seedMakerExpectedQuantity(crop.Seed);
        for (let idx_1 = 0; idx_1 <= (validQualities.length - 1); idx_1++) {
            const quality_8 = item_4(idx_1, validQualities) | 0;
            void (variables.push([new Profit_Variable(2, [item_3, quality_8]), [["Seeds", quantity_1], [item_3.toString() + ("@" + int32ToString(quality_8)), 1]]]));
        }
    }
    const oneOfEachItemUsed = map_1((quantity_2) => [quantity_2, -1], allocatedToForageSeeds);
    if (patternInput[0]) {
        const price_2 = Game_seedItemSellPrice(data, settings.Game, crop.Seed);
        void (variables.push([new Profit_Variable(4, []), append_1([["Profit", 10 * price_2]], oneOfEachItemUsed)]));
    }
    if ((seedTarget > 0) && patternInput[1]) {
        void (variables.push([new Profit_Variable(5, []), append_1([["Seeds", 10]], oneOfEachItemUsed)]));
    }
    return solve({
        constraints: constraints,
        direction: "maximize",
        objective: "Profit",
        variables: variables,
    }, undefined);
}

function Profit_forageCropNetProfitPerHarvest(data, settings, crop, seedPrice) {
    const prices = Profit_cropItemNormalizedPricesByQuality(data, settings, crop.Seed, crop.Foragables);
    const quantities = Game_forageCropItemQuantityByQuality(settings.Game, crop);
    if (Selected_unlockedForageSeedsAnyUsage(settings, crop)) {
        const solution = Profit_forageCropNetProfitSolution(data, settings, crop, 1, seedPrice, prices, quantities);
        return solution.result;
    }
    else {
        return map((cost) => (Profit_forageCropProfitPerHarvestCalc(prices, quantities) - cost), Profit_trySeedCost(data, settings, seedPrice, new Crop(1, [crop]), prices, [quantities], 1));
    }
}

function Profit_forageCropIgnoreSeedsProfitPerHarvest(data, settings, crop) {
    const prices = Profit_cropItemNormalizedPricesByQuality(data, settings, crop.Seed, crop.Foragables);
    const quantities = Game_forageCropItemQuantityByQuality(settings.Game, crop);
    if (Selected_unlockedForageSeedsSellAndUse(settings, crop)[0]) {
        const solution = Profit_forageCropNetProfitSolution(data, settings, crop, 0, undefined, prices, quantities);
        return solution.result;
    }
    else {
        return Profit_forageCropProfitPerHarvestCalc(prices, quantities);
    }
}

function Profit_farmCropIgnoreSeedsProfitPerHarvest(data, settings, crop) {
    const prices = Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop);
    return (fertilizer) => Profit_profitCalc(prices, Game_farmCropItemQuantitiesByQuality(settings.Game, fertilizer, crop));
}

function Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop) {
    if (crop.tag === 1) {
        const x = Profit_forageCropIgnoreSeedsProfitPerHarvest(data, settings, crop.fields[0]);
        return (arg10$0040) => x;
    }
    else {
        return Profit_farmCropIgnoreSeedsProfitPerHarvest(data, settings, crop.fields[0]);
    }
}

function Profit_cropProfitAndSeedPrice(data, settings, crop) {
    return map((seedPrice) => {
        const profitPerHarvest = Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop);
        return (fertilizer) => [profitPerHarvest(fertilizer), seedPrice];
    }, Price_seedMinPrice(data, settings, CropModule_seed(crop)));
}

function Profit_nonRegrowCropStockpileSeedsProfitPerHarvest(data, settings, crop) {
    const seedPrice = Price_seedMinPrice(data, settings, CropModule_seed(crop));
    if (crop.tag === 1) {
        return map((x) => ((arg10$0040) => x), Profit_forageCropNetProfitPerHarvest(data, settings, crop.fields[0], seedPrice));
    }
    else {
        const crop_1 = crop.fields[0];
        const prices = Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop_1);
        return map((seedCost) => ((fertilizer) => {
            const quantities = Game_farmCropItemQuantitiesByQuality(settings.Game, fertilizer, crop_1);
            return Profit_profitCalc(prices, quantities) - seedCost(quantities)(1);
        }), Profit_farmCropTrySeedCost(data, settings, seedPrice, crop_1, prices));
    }
}

function Profit_regrowDataStockpileSeeds(data, settings, crop) {
    const seedPrice = Price_seedMinPrice(data, settings, crop.Seed);
    const prices = Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop);
    return map((_arg) => ((fertilizer) => {
        let value_1, value;
        const quantities = Game_farmCropItemQuantitiesByQuality(settings.Game, fertilizer, crop);
        const profit = Profit_profitCalc(prices, quantities);
        const costsAndLimits = Profit_seedOpportunityCostsAndQuantityPerHarvest(data, settings, seedPrice, new Crop(0, [crop]), prices, quantities);
        const matchValue = tryHead(costsAndLimits);
        if (matchValue != null) {
            const cost = matchValue[0];
            return new RegrowCropProfitData(profit, (value_1 = ((value = (1 / matchValue[1]), Math.ceil(value))), value_1 >>> 0), cost, (arg) => value_4(Profit_seedCostCalc(seedPrice, costsAndLimits, arg)));
        }
        else {
            return Profit_constantRegrowData(profit, value_4(seedPrice));
        }
    }), Profit_farmCropTrySeedCost(data, settings, seedPrice, crop, prices));
}

function Profit_nonRegrowCropProfitPerHarvest(data, settings, crop) {
    const matchValue = settings.Profit.SeedStrategy;
    switch (matchValue.tag) {
        case 1:
            return Profit_nonRegrowCropStockpileSeedsProfitPerHarvest(data, settings, crop);
        case 0:
            return map((profitAndPrice) => ((fertilizer) => {
                const patternInput = profitAndPrice(fertilizer);
                return patternInput[0] - patternInput[1];
            }), Profit_cropProfitAndSeedPrice(data, settings, crop));
        default:
            return Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop);
    }
}

function Profit_regrowCropProfitData(data, settings, crop) {
    const matchValue = settings.Profit.SeedStrategy;
    switch (matchValue.tag) {
        case 1:
            return Profit_regrowDataStockpileSeeds(data, settings, crop);
        case 0:
            return map((profitAndPrice) => ((fertilizer_1) => {
                const tupledArg = profitAndPrice(fertilizer_1);
                return Profit_constantRegrowData(tupledArg[0], tupledArg[1]);
            }), Profit_cropProfitAndSeedPrice(data, settings, new Crop(0, [crop])));
        default: {
            const profit = Profit_farmCropIgnoreSeedsProfitPerHarvest(data, settings, crop);
            return (fertilizer) => Profit_constantRegrowData(profit(fertilizer), 0);
        }
    }
}

function Profit_ignoreSeeds(data, settings, crop) {
    const profit = Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop);
    return (fertilizer) => ((harvests) => (profit(fertilizer) * harvests));
}

function Profit_stockpileSeeds(data, settings, crop) {
    const seedPrice = Price_seedMinPrice(data, settings, CropModule_seed(crop));
    if (crop.tag === 1) {
        return map((net) => ((_arg) => ((harvests_1) => (net * harvests_1))), Profit_forageCropNetProfitPerHarvest(data, settings, crop.fields[0], seedPrice));
    }
    else {
        const crop_1 = crop.fields[0];
        const prices = Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop_1);
        return map((seedCost) => ((fertilizer) => ((harvests) => {
            const quantities = Game_farmCropItemQuantitiesByQuality(settings.Game, fertilizer, crop_1);
            const patternInput = (crop_1.RegrowTime != null) ? [harvests, 1] : [1, harvests];
            return (Profit_profitCalc(prices, quantities) * harvests) - (seedCost(quantities)(patternInput[0]) * patternInput[1]);
        })), Profit_farmCropTrySeedCost(data, settings, seedPrice, crop_1, prices));
    }
}

function Profit_buyFirstSeed(data, settings, crop, seedPrice) {
    if (crop.tag === 1) {
        const profit_1 = Profit_forageCropIgnoreSeedsProfitPerHarvest(data, settings, crop.fields[0]);
        const net = value_4(Profit_forageCropNetProfitPerHarvest(data, settings, crop.fields[0], seedPrice));
        return (_arg) => ((harvests_2) => (profit_1 + (net * (harvests_2 - 1))));
    }
    else if (crop.fields[0].RegrowTime != null) {
        return Profit_ignoreSeeds(data, settings, crop);
    }
    else {
        const prices = Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop.fields[0]);
        return (fertilizer) => ((harvests_1) => {
            const quantities_1 = Game_farmCropItemQuantitiesByQuality(settings.Game, fertilizer, crop.fields[0]);
            return (Profit_profitCalc(prices, quantities_1) * harvests_1) - (value_4(Profit_trySeedCost(data, settings, seedPrice, new Crop(0, [crop.fields[0]]), prices, quantities_1, 1)) * (harvests_1 - 1));
        });
    }
}

function Profit_mapData(mapping, data, settings, timeNormalization, crop) {
    let seedPriceAndProfit;
    const matchValue = settings.Profit.SeedStrategy;
    seedPriceAndProfit = ((matchValue.tag === 1) ? map((profit) => [0, profit], Profit_stockpileSeeds(data, settings, crop)) : ((matchValue.tag === 0) ? map((price) => [price, Profit_buyFirstSeed(data, settings, crop, price)], Price_seedMinPrice(data, settings, CropModule_seed(crop))) : [0, Profit_ignoreSeeds(data, settings, crop)]));
    return (arg) => {
        let fertilizer, growthSpan, fertCost, fertCost_1, profit_1, seedPrice, span, replacementCost, divisor, investment;
        return mapping((fertilizer = arg, (growthSpan = bestGrowthSpan(settings.Game, fertilizer, crop), (fertCost = fertilizerCostOpt(data, settings)(FertilizerModule_Opt_name(fertilizer)), (growthSpan != null) ? ((seedPriceAndProfit != null) ? ((fertCost != null) ? ((fertCost_1 = fertCost, (profit_1 = seedPriceAndProfit[1], (seedPrice = seedPriceAndProfit[0], (span = growthSpan, (replacementCost = ((fertCost_1 * replacedFertilizerPerHarvest(settings, crop)) * (span.Harvests - 1)), (divisor = timeNormalizationDivisor(span, crop, timeNormalization), (investment = (seedPrice + fertCost_1), new FSharpResult$2(0, [[(profit_1(fertilizer)(span.Harvests) - replacementCost) - investment, investment, divisor]]))))))))) : invalidReasons(growthSpan != null, fertCost != null, seedPriceAndProfit != null)) : invalidReasons(growthSpan != null, fertCost != null, seedPriceAndProfit != null)) : invalidReasons(growthSpan != null, fertCost != null, seedPriceAndProfit != null)))));
    };
}

function XP_nonRegrowCropXpPerHarvest(data, settings, crop) {
    if (!canMakeEnoughSeeds(data, settings, crop)) {
        return undefined;
    }
    else {
        return Game_xpPerHarvest(data, settings.Game, crop);
    }
}

function XP_regrowCropXpData(data, settings, crop) {
    const crop_1 = new Crop(0, [crop]);
    if (!canMakeEnoughSeeds(data, settings, crop_1)) {
        return undefined;
    }
    else {
        return new RegrowCropProfitData(Game_xpPerHarvest(data, settings.Game, crop_1), 1, 0, (arg10$0040) => 0);
    }
}

export class SoldItemSummary extends Record {
    constructor(Item, Quality, Price, Quantity, Custom) {
        super();
        this.Item = Item;
        this.Quality = (Quality | 0);
        this.Price = Price;
        this.Quantity = Quantity;
        this.Custom = Custom;
    }
}

export function SoldItemSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.SoldItemSummary", [], SoldItemSummary, () => [["Item", uint32_type], ["Quality", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])], ["Price", uint32_type], ["Quantity", float64_type], ["Custom", bool_type]]);
}

export class SoldProductSummary extends Record {
    constructor(Product, Quality, Price, Quantity, ConsumedItemQuantities) {
        super();
        this.Product = Product;
        this.Quality = (Quality | 0);
        this.Price = Price;
        this.Quantity = Quantity;
        this.ConsumedItemQuantities = ConsumedItemQuantities;
    }
}

export function SoldProductSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.SoldProductSummary", [], SoldProductSummary, () => [["Product", Product_$reflection()], ["Quality", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])], ["Price", uint32_type], ["Quantity", float64_type], ["ConsumedItemQuantities", array_type(tuple_type(tuple_type(uint32_type, enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])), float64_type))]]);
}

export class CropProfitSummary extends Record {
    constructor(Crop, Harvests, ReplacedFertilizer, SeedPrice, UnsoldItems, SoldItems, SoldProducts, SeedsUsed, SeedsBought, ForageSeedsSold, ForageSeedsUsed, NetProfit) {
        super();
        this.Crop = Crop;
        this.Harvests = Harvests;
        this.ReplacedFertilizer = ReplacedFertilizer;
        this.SeedPrice = SeedPrice;
        this.UnsoldItems = UnsoldItems;
        this.SoldItems = SoldItems;
        this.SoldProducts = SoldProducts;
        this.SeedsUsed = SeedsUsed;
        this.SeedsBought = SeedsBought;
        this.ForageSeedsSold = ForageSeedsSold;
        this.ForageSeedsUsed = ForageSeedsUsed;
        this.NetProfit = NetProfit;
    }
}

export function CropProfitSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.CropProfitSummary", [], CropProfitSummary, () => [["Crop", Crop_$reflection()], ["Harvests", uint32_type], ["ReplacedFertilizer", float64_type], ["SeedPrice", option_type(tuple_type(CustomChoice$2_$reflection(string_type, unit_type), uint32_type))], ["UnsoldItems", array_type(tuple_type(uint32_type, Qualities$1_$reflection(float64_type)))], ["SoldItems", array_type(SoldItemSummary_$reflection())], ["SoldProducts", array_type(SoldProductSummary_$reflection())], ["SeedsUsed", array_type(tuple_type(uint32_type, Qualities$1_$reflection(float64_type)))], ["SeedsBought", float64_type], ["ForageSeedsSold", float64_type], ["ForageSeedsUsed", float64_type], ["NetProfit", option_type(float64_type)]]);
}

export class ProfitSummary extends Record {
    constructor(Fertilizer, FertilizerPrice, CropSummaries, NetProfit, TimeNormalization) {
        super();
        this.Fertilizer = Fertilizer;
        this.FertilizerPrice = FertilizerPrice;
        this.CropSummaries = CropSummaries;
        this.NetProfit = NetProfit;
        this.TimeNormalization = TimeNormalization;
    }
}

export function ProfitSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.ProfitSummary", [], ProfitSummary, () => [["Fertilizer", option_type(Fertilizer_$reflection())], ["FertilizerPrice", option_type(option_type(tuple_type(CustomChoice$2_$reflection(string_type, unit_type), uint32_type)))], ["CropSummaries", array_type(CropProfitSummary_$reflection())], ["NetProfit", option_type(float64_type)], ["TimeNormalization", float64_type]]);
}

export function ProfitSummaryModule_investmentAndRoi(buyFirstSeed, summary) {
    const fertPrice = Option_defaultOrMap(0, (option) => map((tuple) => tuple[1], option), summary.FertilizerPrice);
    const seedPrice = buyFirstSeed ? map((tuple_1) => tuple_1[1], item_4(0, summary.CropSummaries).SeedPrice) : 0;
    const matchValue = summary.NetProfit;
    let matchResult, fertPrice_1, net, seedPrice_1;
    if (matchValue != null) {
        if (fertPrice != null) {
            if (seedPrice != null) {
                matchResult = 0;
                fertPrice_1 = fertPrice;
                net = matchValue;
                seedPrice_1 = seedPrice;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const investment = fertPrice_1 + seedPrice_1;
            return [investment, (investment === 0) ? undefined : (net / investment)];
        }
        default:
            return [undefined, undefined];
    }
}

class ProfitSummaryCalc_ItemAndSeedSummary extends Record {
    constructor(Profit, SoldQuantities, SeedsUsed, SeedsBought, ForageSeedsSold, ForageSeedsUsed) {
        super();
        this.Profit = Profit;
        this.SoldQuantities = SoldQuantities;
        this.SeedsUsed = SeedsUsed;
        this.SeedsBought = SeedsBought;
        this.ForageSeedsSold = ForageSeedsSold;
        this.ForageSeedsUsed = ForageSeedsUsed;
    }
}

function ProfitSummaryCalc_ItemAndSeedSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.ProfitSummaryCalc.ItemAndSeedSummary", [], ProfitSummaryCalc_ItemAndSeedSummary, () => [["Profit", option_type(float64_type)], ["SoldQuantities", array_type(Qualities$1_$reflection(float64_type))], ["SeedsUsed", array_type(tuple_type(uint32_type, Qualities$1_$reflection(float64_type)))], ["SeedsBought", float64_type], ["ForageSeedsSold", float64_type], ["ForageSeedsUsed", float64_type]]);
}

const ProfitSummaryCalc_ItemAndSeedSummaryModule_zero = new ProfitSummaryCalc_ItemAndSeedSummary(0, [], [], 0, 0, 0);

function ProfitSummaryCalc_seedCostAndQuantityData(data, settings, crop, seedPrice, items, prices, quantities) {
    const seedCostAndQuantity = [];
    const seedPriceValue = Option_defaultOrMap(Infinity, (value) => value, seedPrice);
    const addCostAndQuantity = (item, seedsPerItem) => {
        const prices_1 = item_4(item, prices);
        const quantities_1 = item_4(item, quantities);
        for (let i = 0; i <= 3; i++) {
            const quality = i | 0;
            const cost = item_4(quality, prices_1.fields[0]) / seedsPerItem;
            const quantities_2 = item_4(quality, quantities_1.fields[0]);
            if ((cost < seedPriceValue) && (quantities_2 > 0)) {
                void (seedCostAndQuantity.push({
                    ItemIndex: item,
                    OpportunityCostPerSeed: cost,
                    Quality: quality,
                    Quantity: quantities_2,
                    SeedsPerConsumedItem: seedsPerItem,
                }));
            }
        }
    };
    const seed = CropModule_seed(crop);
    if (Selected_unlockedUseSeedsFromSeedMaker(data, settings, crop)) {
        addCostAndQuantity(0, ProcessorModule_seedMakerExpectedQuantity(seed));
    }
    iterate((i_1) => {
        addCostAndQuantity(i_1, 1);
    }, toArray_1(tryFindIndex((item_1) => Selected_useHarvestedSeeds(settings, seed, item_1), items)));
    const seedCostAndQuantity_1 = seedCostAndQuantity;
    seedCostAndQuantity_1.sort((a, b) => Util_compareBy((_arg_3) => _arg_3.OpportunityCostPerSeed, a, b));
    return seedCostAndQuantity_1;
}

function ProfitSummaryCalc_partitionQuantitiesForSeeds(data, settings, crop, seedPrice, prices, quantities, harvests) {
    let array_4;
    const items = CropModule_items(crop);
    const seedCostAndQuantity = ProfitSummaryCalc_seedCostAndQuantityData(data, settings, crop, seedPrice, items, prices, quantities);
    const quantitiesConsumedForSeeds = map_1((_arg) => (new Float64Array(4)), items);
    let seedsLeft = CropModule_regrows(crop) ? 1 : harvests;
    let i = 0;
    while ((i < seedCostAndQuantity.length) && (seedsLeft > 0)) {
        const data_1 = item_4(i, seedCostAndQuantity);
        const seedsMade = min_2(seedsLeft, data_1.Quantity * data_1.SeedsPerConsumedItem);
        item_4(data_1.ItemIndex, quantitiesConsumedForSeeds)[data_1.Quality] = (seedsMade / data_1.SeedsPerConsumedItem);
        seedsLeft = (seedsLeft - seedsMade);
        i = ((i + 1) | 0);
    }
    const quantitiesConsumedForSeeds_1 = map_1((arr) => (new Qualities$1(arr)), quantitiesConsumedForSeeds);
    return [map2((arg10$0040, arg20$0040) => (new Qualities$1(map2((x, y) => (x - y), arg10$0040.fields[0], arg20$0040.fields[0], Float64Array))), quantities, quantitiesConsumedForSeeds_1), (array_4 = zip(items, quantitiesConsumedForSeeds_1), array_4.filter((tupledArg) => !equals(tupledArg[1], Qualities_zero))), seedsLeft];
}

function ProfitSummaryCalc_nonForageItemAndSeedSummary(makeSeeds, data, settings, crop, seedPrice, prices, quantities, harvests) {
    const quantities_1 = (harvests === 1) ? quantities : map_1((qualities) => Qualities_mult(harvests, qualities), quantities);
    const patternInput = makeSeeds ? ProfitSummaryCalc_partitionQuantitiesForSeeds(data, settings, crop, seedPrice, prices, quantities_1, harvests) : [quantities_1, [], 0];
    const soldQuantities = patternInput[0];
    const seedsBought = patternInput[2];
    const profit = Profit_profitCalc(prices, soldQuantities);
    const bind$0040 = ProfitSummaryCalc_ItemAndSeedSummaryModule_zero;
    return new ProfitSummaryCalc_ItemAndSeedSummary((seedPrice == null) ? ((seedsBought === 0) ? profit : undefined) : (profit - (seedPrice * seedsBought)), soldQuantities, patternInput[1], seedsBought, bind$0040.ForageSeedsSold, bind$0040.ForageSeedsUsed);
}

function ProfitSummaryCalc_itemQuantities(harvests, variableFilter, solution) {
    return map_1((tupledArg) => {
        const usage = tupledArg[1];
        const quantities = new Float64Array(4);
        for (let idx = 0; idx <= (usage.length - 1); idx++) {
            const forLoopVar = item_4(idx, usage);
            setItem(quantities, forLoopVar[1][0], forLoopVar[1][1] * harvests);
        }
        return [tupledArg[0], new Qualities$1(quantities)];
    }, Array_groupBy((tuple) => tuple[0], choose(variableFilter, solution.variables), {
        Equals: equals,
        GetHashCode: structuralHash,
    }));
}

function ProfitSummaryCalc_variableCount(variable, harvests, solution) {
    return Option_defaultOrMap(0, (tuple_1) => tuple_1[1], tryFind((arg) => equals(variable, arg[0]), solution.variables)) * harvests;
}

function ProfitSummaryCalc_forageCropItemAndSeedSummary(makeSeeds, data, settings, crop, seedPrice, prices, quantities, harvests) {
    const seedTarget = makeSeeds ? min_2(1, forageCropMaxNonBoughtSeeds(data, settings, crop)) : 0;
    const solution = Profit_forageCropNetProfitSolution(data, settings, crop, seedTarget, seedPrice, prices, quantities);
    const soldQuantities = ProfitSummaryCalc_itemQuantities(harvests, (_arg) => {
        if (_arg[0].tag === 1) {
            return [_arg[0].fields[0], [_arg[0].fields[1], _arg[1]]];
        }
        else {
            return undefined;
        }
    }, solution);
    const soldsoldQuantities = map_1((item_1) => Option_defaultOrMap(Qualities_zero, (tuple_1) => tuple_1[1], tryFind((arg) => (item_1 === arg[0]), soldQuantities)), crop.Foragables);
    const seedsUsed = ProfitSummaryCalc_itemQuantities(harvests, (_arg_2) => {
        if (_arg_2[0].tag === 2) {
            return [_arg_2[0].fields[0], [_arg_2[0].fields[1], _arg_2[1]]];
        }
        else {
            return undefined;
        }
    }, solution);
    const seedsBought = ProfitSummaryCalc_variableCount(new Profit_Variable(0, []), harvests, solution);
    return new ProfitSummaryCalc_ItemAndSeedSummary((!makeSeeds ? true : (seedTarget === 1)) ? (solution.result * harvests) : undefined, soldsoldQuantities, seedsUsed, (seedPrice == null) ? ((seedsBought === 0) ? 0 : ((1 - seedTarget) * harvests)) : seedsBought, 10 * ProfitSummaryCalc_variableCount(new Profit_Variable(4, []), harvests, solution), 10 * ProfitSummaryCalc_variableCount(new Profit_Variable(5, []), harvests, solution));
}

function ProfitSummaryCalc_soldItemsAndProducts(data, settings, items, sellAs, soldQuantities) {
    const unsoldItems = [];
    const soldItems = [];
    const soldProducts = [];
    for (let i = 0; i <= (items.length - 1); i++) {
        const item = item_4(i, items);
        const quantities = item_4(i, soldQuantities);
        const matchValue = item_4(i, sellAs);
        if (matchValue != null) {
            const sellAs_1 = matchValue;
            for (let i_1 = 0; i_1 <= 3; i_1++) {
                const quality = i_1 | 0;
                const quantity = item_4(quality, quantities.fields[0]);
                if (quantity === 0) {
                }
                else {
                    const patternInput = item_4(quality, sellAs_1.fields[0]);
                    const sellAs_2 = patternInput[0];
                    let matchResult, product;
                    if (sellAs_2 != null) {
                        if (sellAs_2.tag === 0) {
                            matchResult = 1;
                            product = sellAs_2.fields[0];
                        }
                        else {
                            matchResult = 0;
                        }
                    }
                    else {
                        matchResult = 0;
                    }
                    switch (matchResult) {
                        case 0: {
                            void (soldItems.push(new SoldItemSummary(item, quality, patternInput[1] >>> 0, quantity, sellAs_2 != null)));
                            break;
                        }
                        case 1: {
                            const patternInput_1 = Game_productPriceAndQuality(data, settings.Game, quality, product);
                            void (soldProducts.push([[[item, quality], quantity], [product, patternInput_1[1], patternInput_1[0]]]));
                            break;
                        }
                    }
                }
            }
        }
        else {
            void (unsoldItems.push([item, quantities]));
        }
    }
    return [unsoldItems, soldItems, map_1((tupledArg) => {
        const _arg_2 = tupledArg[0];
        const product_1 = _arg_2[0];
        const items_2 = map_1((tuple_1) => tuple_1[0], tupledArg[1]);
        return new SoldProductSummary(product_1, _arg_2[1], _arg_2[2], sumBy((tuple_2) => tuple_2[1], items_2, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        }) * ProductModule_quantityPerInput(product_1), items_2);
    }, Array_groupBy((tuple) => tuple[1], soldProducts, {
        Equals: equalArrays,
        GetHashCode: arrayHash,
    }))];
}

function ProfitSummaryCalc_harvestSummary(forageItemAndSeedSummary, nonForageItemAndSeedSummary, data, settings, fertilizerPrice, fertilizer, lastCrop, crop, harvests) {
    let matchValue, profit, profit_2, cost, profit_1;
    const seed = CropModule_seed(crop);
    const seedVendorAndPrice = Price_seedMinVendorAndPrice(data, settings, seed);
    const seedPrice = map((tuple) => tuple[1], seedVendorAndPrice);
    const replacedFertilizer = replacedFertilizerPerHarvest(settings, crop) * (harvests - (lastCrop ? 1 : 0));
    const sellAs = map_1((item) => Price_itemMaxSellAsAndNormalizedPrice(data, settings, seed, item), CropModule_items(crop));
    const prices = map_1((_arg_2) => Option_defaultOrMap(Qualities_zero, (arg10$0040) => (new Qualities$1(map_1((tuple_1) => tuple_1[1], arg10$0040.fields[0], Float64Array))), _arg_2), sellAs);
    const summary = (crop.tag === 1) ? (Selected_unlockedForageSeedsAnyUsage(settings, crop.fields[0]) ? forageItemAndSeedSummary(data, settings, crop.fields[0], seedPrice, prices, Game_forageCropItemQuantityByQuality(settings.Game, crop.fields[0]), harvests) : nonForageItemAndSeedSummary(data, settings, crop, seedPrice, prices, Game_cropItemQuantitiesByQuality(settings.Game, fertilizer, crop), harvests)) : nonForageItemAndSeedSummary(data, settings, crop, seedPrice, prices, Game_cropItemQuantitiesByQuality(settings.Game, fertilizer, crop), harvests);
    const patternInput = ProfitSummaryCalc_soldItemsAndProducts(data, settings, CropModule_items(crop), sellAs, summary.SoldQuantities);
    return new CropProfitSummary(crop, harvests, replacedFertilizer, seedVendorAndPrice, patternInput[0], patternInput[1], patternInput[2], summary.SeedsUsed, summary.SeedsBought, summary.ForageSeedsSold, summary.ForageSeedsUsed, (matchValue = summary.Profit, (matchValue != null) ? ((fertilizerPrice == null) ? (((profit = matchValue, replacedFertilizer === 0)) ? ((profit_2 = matchValue, profit_2)) : undefined) : ((cost = fertilizerPrice, (profit_1 = matchValue, profit_1 - (cost * replacedFertilizer))))) : undefined));
}

const ProfitSummaryCalc_ignoreSeeds = (data_2) => ((settings_2) => ((fertilizerPrice) => ((fertilizer) => ((lastCrop) => ((crop_2) => ((harvests_2) => ProfitSummaryCalc_harvestSummary((data, settings, crop, seedPrice, prices, quantities, harvests) => ProfitSummaryCalc_forageCropItemAndSeedSummary(false, data, settings, crop, seedPrice, prices, quantities, harvests), (data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1) => ProfitSummaryCalc_nonForageItemAndSeedSummary(false, data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1), data_2, settings_2, fertilizerPrice, fertilizer, lastCrop, crop_2, harvests_2)))))));

const ProfitSummaryCalc_stockpileSeeds = (data_2) => ((settings_2) => ((fertilizerPrice) => ((fertilizer) => ((lastCrop) => ((crop_2) => ((harvests_2) => ProfitSummaryCalc_harvestSummary((data, settings, crop, seedPrice, prices, quantities, harvests) => ProfitSummaryCalc_forageCropItemAndSeedSummary(true, data, settings, crop, seedPrice, prices, quantities, harvests), (data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1) => ProfitSummaryCalc_nonForageItemAndSeedSummary(true, data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1), data_2, settings_2, fertilizerPrice, fertilizer, lastCrop, crop_2, harvests_2)))))));

function ProfitSummaryCalc_buyFirstSeedItemSummary(itemAndSeedSummary, data, settings, crop, seedPrice, prices, quantities, harvests) {
    const firstSummary = itemAndSeedSummary(false, data, settings, crop, seedPrice, prices, quantities, 1);
    const summary = itemAndSeedSummary(true, data, settings, crop, seedPrice, prices, quantities, harvests - 1);
    return new ProfitSummaryCalc_ItemAndSeedSummary(map3((seedPrice_1, firstProfit, profit) => ((firstProfit + profit) - seedPrice_1), seedPrice, firstSummary.Profit, summary.Profit), map2((arg10$0040, arg20$0040) => (new Qualities$1(map2((x, y) => (x + y), arg10$0040.fields[0], arg20$0040.fields[0], Float64Array))), firstSummary.SoldQuantities, summary.SoldQuantities), summary.SeedsUsed, summary.SeedsBought + 1, firstSummary.ForageSeedsSold + summary.ForageSeedsSold, summary.ForageSeedsUsed);
}

const ProfitSummaryCalc_buyFirstSeed = (data_4) => ((settings_4) => ((fertilizerPrice) => ((fertilizer) => ((lastCrop) => ((crop_4) => ((harvests_4) => ProfitSummaryCalc_harvestSummary((data, settings, crop, seedPrice, prices, quantities, harvests) => ProfitSummaryCalc_buyFirstSeedItemSummary(ProfitSummaryCalc_forageCropItemAndSeedSummary, data, settings, crop, seedPrice, prices, quantities, harvests), (data_2, settings_2, crop_2, seedPrice_2, prices_2, quantities_2, harvests_2) => {
    if (CropModule_regrows(crop_2)) {
        const summary = ProfitSummaryCalc_nonForageItemAndSeedSummary(false, data_2, settings_2, crop_2, seedPrice_2, prices_2, quantities_2, harvests_2);
        return new ProfitSummaryCalc_ItemAndSeedSummary(map2_1((profit, seedPrice_3) => (profit - seedPrice_3), summary.Profit, seedPrice_2), summary.SoldQuantities, summary.SeedsUsed, 1, summary.ForageSeedsSold, summary.ForageSeedsUsed);
    }
    else {
        return ProfitSummaryCalc_buyFirstSeedItemSummary(ProfitSummaryCalc_nonForageItemAndSeedSummary, data_2, settings_2, crop_2, seedPrice_2, prices_2, quantities_2, harvests_2);
    }
}, data_4, settings_4, fertilizerPrice, fertilizer, lastCrop, crop_4, harvests_4)))))));

export class CropXpSummary extends Record {
    constructor(Crop, Harvests, XpPerItem, ItemQuantity) {
        super();
        this.Crop = Crop;
        this.Harvests = Harvests;
        this.XpPerItem = XpPerItem;
        this.ItemQuantity = ItemQuantity;
    }
}

export function CropXpSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.CropXpSummary", [], CropXpSummary, () => [["Crop", Crop_$reflection()], ["Harvests", uint32_type], ["XpPerItem", uint32_type], ["ItemQuantity", float64_type]]);
}

export function CropXpSummaryModule_totalXp(summary) {
    return summary.XpPerItem * summary.ItemQuantity;
}

export class XpSummary extends Record {
    constructor(Fertilizer, CropSummaries, Xp, TimeNormalization) {
        super();
        this.Fertilizer = Fertilizer;
        this.CropSummaries = CropSummaries;
        this.Xp = Xp;
        this.TimeNormalization = TimeNormalization;
    }
}

export function XpSummary_$reflection() {
    return record_type("StardewValleyStonks.WebApp.Query.XpSummary", [], XpSummary, () => [["Fertilizer", option_type(Fertilizer_$reflection())], ["CropSummaries", array_type(CropXpSummary_$reflection())], ["Xp", float64_type], ["TimeNormalization", float64_type]]);
}

function cropXpSummary(data, settings, crop, harvests) {
    return new CropXpSummary(crop, harvests, Game_xpPerItem(data, crop), Game_xpItemsPerHarvest(settings.Game, crop) * harvests);
}

export const Ranker_profit = (data) => ((settings) => ((timeNormalization) => ((crop) => Profit_mapData((result) => Result_Map((tupledArg) => (tupledArg[0] / tupledArg[2]), result), data, settings, timeNormalization, crop))));

export const Ranker_roi = (data) => ((settings) => ((timeNormalization) => ((crop) => Profit_mapData((result) => Result_Bind((tupledArg) => {
    const investment = tupledArg[1];
    if (investment === 0) {
        return new FSharpResult$2(1, [8]);
    }
    else {
        return new FSharpResult$2(0, [(tupledArg[0] / investment) / tupledArg[2]]);
    }
}, result), data, settings, timeNormalization, crop))));

export function Ranker_xp(data, settings, timeNorm, crop) {
    const enoughSeeds = canMakeEnoughSeeds(data, settings, crop);
    return (fertilizer) => {
        let span;
        const hasFertPrice = fertilizerCostOpt(data, settings)(FertilizerModule_Opt_name(fertilizer)) != null;
        const matchValue = bestGrowthSpan(settings.Game, fertilizer, crop);
        let matchResult, span_1, span_2;
        if (matchValue != null) {
            if ((span = matchValue, hasFertPrice && enoughSeeds)) {
                matchResult = 0;
                span_1 = matchValue;
            }
            else {
                matchResult = 1;
                span_2 = matchValue;
            }
        }
        else {
            matchResult = 1;
            span_2 = matchValue;
        }
        switch (matchResult) {
            case 0:
                return new FSharpResult$2(0, [(Game_xpPerHarvest(data, settings.Game, crop) * span_1.Harvests) / timeNormalizationDivisor(span_1, crop, timeNorm)]);
            default:
                return invalidReasons(span_2 != null, hasFertPrice, enoughSeeds);
        }
    };
}

export function Ranker_rankValue(_arg) {
    switch (_arg.tag) {
        case 1:
            return Ranker_roi;
        case 2:
            return (data) => ((settings) => ((timeNorm) => ((crop) => Ranker_xp(data, settings, timeNorm, crop))));
        default:
            return Ranker_profit;
    }
}

export function Ranker_profitSummary(data, settings, timeNormalization, fertilizer, crop) {
    return map((span) => {
        const fertilizerVendorAndPrice = fertilizerRelevantVendorAndPrice(data, settings, fertilizer);
        const fertCost = Option_defaultOrMap(0, (option) => map((tuple) => tuple[1], option), fertilizerVendorAndPrice);
        let summary;
        const matchValue = settings.Profit.SeedStrategy;
        summary = ((matchValue.tag === 1) ? ProfitSummaryCalc_stockpileSeeds(data)(settings)(fertCost)(fertilizer)(true)(crop)(span.Harvests) : ((matchValue.tag === 0) ? ProfitSummaryCalc_buyFirstSeed(data)(settings)(fertCost)(fertilizer)(true)(crop)(span.Harvests) : ProfitSummaryCalc_ignoreSeeds(data)(settings)(fertCost)(fertilizer)(true)(crop)(span.Harvests)));
        return new ProfitSummary(fertilizer, fertilizerVendorAndPrice, [summary], map2_1((profit, fertCost_1) => (profit - fertCost_1), summary.NetProfit, fertCost), timeNormalizationDivisor(span, crop, timeNormalization));
    }, bestGrowthSpan(settings.Game, fertilizer, crop));
}

export function Ranker_xpSummary(data, settings, timeNorm, fertilizer, crop) {
    let span;
    const hasFertPrice = fertilizerCostOpt(data, settings)(FertilizerModule_Opt_name(fertilizer)) != null;
    const enoughSeeds = canMakeEnoughSeeds(data, settings, crop);
    const matchValue = bestGrowthSpan(settings.Game, fertilizer, crop);
    let matchResult, span_1, span_2;
    if (matchValue != null) {
        if ((span = matchValue, hasFertPrice && enoughSeeds)) {
            matchResult = 0;
            span_1 = matchValue;
        }
        else {
            matchResult = 1;
            span_2 = matchValue;
        }
    }
    else {
        matchResult = 1;
        span_2 = matchValue;
    }
    switch (matchResult) {
        case 0: {
            const summary = cropXpSummary(data, settings, crop, span_1.Harvests);
            return new FSharpResult$2(0, [new XpSummary(fertilizer, [summary], summary.XpPerItem * summary.ItemQuantity, timeNormalizationDivisor(span_1, crop, timeNorm))]);
        }
        default:
            return invalidReasons(span_2 != null, hasFertPrice, enoughSeeds);
    }
}

export const Optimizer_nonRegrowCropProfitPerHarvest = (data) => ((settings) => ((crop) => Profit_nonRegrowCropProfitPerHarvest(data, settings, crop)));

export const Optimizer_regrowCropProfitData = (data) => ((settings) => ((crop) => Profit_regrowCropProfitData(data, settings, crop)));

export const Optimizer_nonRegrowCropXpPerHarvest = (data) => ((settings) => ((crop) => XP_nonRegrowCropXpPerHarvest(data, settings, crop)));

export const Optimizer_regrowCropXpData = (data) => ((settings) => ((crop) => XP_regrowCropXpData(data, settings, crop)));

export function Optimizer_profitSummary(data, settings, fertilizer, cropHarvests) {
    const fertilizerVendorAndPrice = fertilizerRelevantVendorAndPrice(data, settings, fertilizer);
    const fertCost = Option_defaultOrMap(0, (option) => map((tuple) => tuple[1], option), fertilizerVendorAndPrice);
    let harvestSummary;
    const matchValue = settings.Profit.SeedStrategy;
    harvestSummary = ((matchValue.tag === 1) ? ProfitSummaryCalc_stockpileSeeds(data)(settings)(fertCost)(fertilizer) : ((matchValue.tag === 0) ? ((lastCrop) => ((crop) => ((harvests) => {
        const summary = ProfitSummaryCalc_ignoreSeeds(data)(settings)(fertCost)(fertilizer)(lastCrop)(crop)(harvests);
        const seedsBought = CropModule_regrows(crop) ? 1 : harvests;
        return new CropProfitSummary(summary.Crop, summary.Harvests, summary.ReplacedFertilizer, summary.SeedPrice, summary.UnsoldItems, summary.SoldItems, summary.SoldProducts, summary.SeedsUsed, seedsBought, summary.ForageSeedsSold, summary.ForageSeedsUsed, map2_1((profit, tupledArg) => (profit - (tupledArg[1] * seedsBought)), summary.NetProfit, summary.SeedPrice));
    }))) : ProfitSummaryCalc_ignoreSeeds(data)(settings)(fertCost)(fertilizer)));
    const summaries = mapIndexed((i, tupledArg_1) => harvestSummary(i === (cropHarvests.length - 1))(tupledArg_1[0])(tupledArg_1[1]), cropHarvests);
    return new ProfitSummary(fertilizer, fertilizerVendorAndPrice, summaries, Array_mapReduce((option_3, option_4) => map2_1((x, y) => (x + y), option_3, option_4), (summary_1) => summary_1.NetProfit, summaries), 1);
}

export function Optimizer_xpSummary(data, settings, fertilizer, cropHarvests) {
    const summaries = map_1((tupledArg) => cropXpSummary(data, settings, tupledArg[0], tupledArg[1]), cropHarvests);
    return new XpSummary(fertilizer, summaries, sumBy((summary) => (summary.XpPerItem * summary.ItemQuantity), summaries, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }), 1);
}

//# sourceMappingURL=Query.js.map
